/* Передача итога «Сменить голос» / «Почистить запись» в «Говорящий кружок» («Сделать кружок») или «Заставить говорить»
   новым файлом (voice-result-entry.ts). Без React: родной хвост (VoiceTail) и экран движка вызывают одно и то же.
   Перед передачей заново сверяются владелец (`GET /app/me`) и заказ (`GET /app/orders/{id}`: done, результат доступен, та же ревизия);
   файл — авторизованная выгрузка результата сервера. Любая неудача проверки — исключение: ничего не передано. */
import { endpoints } from '../../api';
import type { SpeechOrder } from '../../api/speech';
import { stageVoiceResult, type VoiceResultUse } from './voice-result-entry';

export async function transferVoiceResult(o: { ownerId: number | undefined; order: SpeechOrder; use: VoiceResultUse }): Promise<void> {
  const { order, use } = o;
  const me = await endpoints.me();
  if (me.user.id !== o.ownerId) throw new Error('owner_changed');
  const fresh = await endpoints.speech.get(order.id);
  const asset = fresh.result?.assets.find(item => item.mime.startsWith('audio/'));
  if (fresh.status !== 'done' || !fresh.result?.available || !asset || fresh.result_revision !== order.result_revision)
    throw new Error('source_changed');
  const blob = await endpoints.speech.result(fresh, asset.index);
  if (!blob.type.startsWith('audio/')) throw new Error('invalid_result');
  stageVoiceResult({
    owner: me.user.id,
    orderId: order.id,
    revision: fresh.result_revision,
    index: asset.index,
    file: new File([blob], asset.file_name || 'steos-voice.mp3', { type: blob.type }),
    use,
  });
}
